import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Sparkles } from 'lucide-react';
import api from '../../services/api';

// Cloche de notifications client (in-app). Réutilise l'état métier des relances d'installation.
export const ClientNotificationBell = () => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const ref = useRef(null);
  const navigate = useNavigate();

  const load = () => {
    api.get('/client/notifications')
      .then((r) => { setItems(r.data.items || []); setUnread(r.data.unread || 0); })
      .catch(() => {});
  };

  useEffect(() => { load(); }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const openNotif = async (n) => {
    try { await api.put(`/client/notifications/${n.id}`, { status: 'read' }); } catch (e) { /* noop */ }
    setOpen(false);
    if (n.cta_route) navigate(n.cta_route);
    load();
  };

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => { setOpen((v) => !v); if (!open) load(); }}
        className="relative flex items-center justify-center w-10 h-10 sm:w-11 sm:h-11 bg-[#1A1A1D] border border-[#3A3A3D] rounded-lg sm:rounded-xl hover:border-[#FF6B35] transition-all"
        data-testid="client-notification-bell"
        aria-label="Notifications"
      >
        <Bell className="h-4 w-4 sm:h-5 sm:w-5 text-[#FF6B35]" />
        {unread > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#FF3B5C] text-white text-[10px] font-bold flex items-center justify-center" data-testid="notification-badge">
            {unread}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-80 max-w-[90vw] bg-[#121214] border border-[#3A3A3D] rounded-xl shadow-2xl z-50 overflow-hidden" data-testid="notification-dropdown">
          <div className="px-4 py-3 border-b border-[#3A3A3D]">
            <p className="text-white text-sm font-semibold">Notifications</p>
          </div>
          <div className="max-h-96 overflow-y-auto">
            {items.length === 0 && <p className="px-4 py-6 text-center text-[#6B6B6E] text-sm">Aucune notification.</p>}
            {items.map((n) => (
              <button
                key={n.id}
                onClick={() => openNotif(n)}
                className={`w-full text-left px-4 py-3 border-b border-[#3A3A3D] hover:bg-[#1A1A1D] transition-colors ${n.status === 'unread' ? 'bg-[#FF6B35]/5' : ''}`}
                data-testid="notification-item"
              >
                <div className="flex items-start gap-2">
                  <Sparkles className="h-4 w-4 text-[#FF6B35] mt-0.5 flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-white text-sm font-medium">{n.title}</p>
                    <p className="text-[#B8B8BA] text-xs mt-0.5 line-clamp-2">{n.message}</p>
                    {n.cta_label && <span className="inline-block mt-1.5 text-[11px] text-[#FF6B35] font-medium">{n.cta_label} →</span>}
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientNotificationBell;
